module.exports = __webpack_public_path__ + "fonts/Muli-Bold.cd2d154d.eot";